import { render } from "./newChatMessage.vue?vue&type=template&id=78d39857&ts=true"
import script from "./newChatMessage.vue?vue&type=script&lang=ts"
export * from "./newChatMessage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__